// drag-drop-transfer.service.ts
import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

@Injectable({ providedIn: 'root' })

export class DragDropTransferService {
  
  private droppedItemSource = new Subject<any>();
  droppedItem$ = this.droppedItemSource.asObservable();

  sendDroppedItem(item: any) {
    this.droppedItemSource.next(item);
  }
}
